<div class="flex">
  <div class="mr-5">
    <ul>
      <li (click)="scroll(Forms)" class="mb-2">Forms</li>
      <ul>
        <li (click)="scroll(Slider)" class="mb-2">Slider</li>
        <li (click)="scroll(Rating)" class="mb-2">Rating</li>
        <li (click)="scroll(InputSwitch)" class="mb-2">InputSwitch</li>
        <li (click)="scroll(FloatLabel)" class="mb-2">FloatLabel</li>
      </ul>
      <li (click)="scroll(Buttons)" class="mb-2">Buttons</li>
      <li (click)="scroll(Data)" class="mb-2">Data</li>
      <ul>
        <li (click)="scroll(Data)" class="mb-2">Table</li>
        <li (click)="scroll(ContextMenu)" class="mb-2">ContextMenu</li>
      </ul>
      <li (click)="scroll(Panels)" class="mb-2">Panels</li>
      <ul>
        <li (click)="scroll(Panel)" class="mb-2">Panel</li>
        <li (click)="scroll(Fieldset)" class="mb-2">Fieldset</li>
      </ul>
      <li (click)="scroll(Overlay)" class="mb-2">Overlay</li>
      <ul>
        <li (click)="scroll(OverlayPanel)" class="mb-2">OverlayPanel</li>
        <li (click)="scroll(ConfirmPopup)" class="mb-2">ConfirmPopup</li>
        <li (click)="scroll(ConfirmDialog)" class="mb-2">ConfirmDialog</li>
      </ul>
      <li (click)="scroll(Menus)" class="mb-2">Menus</li>
      <ul>
        <li (click)="scroll(OverlayMenu)" class="mb-2">OverlayMenu</li>
        <li (click)="scroll(TieredMenu)" class="mb-2">TieredMenu</li>
        <li (click)="scroll(PlainMenu)" class="mb-2">PlainMenu</li>
      </ul>
      <li (click)="scroll(Messages)" class="mb-2">Messages</li>
      <ul>
        <li (click)="scroll(InlineMessage)" class="mb-2">InlineMessage</li>
      </ul>
    </ul>
  </div>
  <div>
    <p-card styleClass="mb-4 p-fluid">
      <h2 #Forms>Forms</h2>
      <hr />

      <h3 #Slider>Slider</h3>
      <input type="text" pInputText [(ngModel)]="sliderValue" readonly />
      <p-slider [(ngModel)]="sliderValue"></p-slider>

      <h3 #Rating>Rating</h3>
      <p-rating [(ngModel)]="ratingValue"></p-rating>

      <h3 #InputSwitch>Input Switch</h3>
      <p-inputSwitch [(ngModel)]="switchValue"></p-inputSwitch>

      <h3 #FloatLabel>Float Label</h3>
      <span class="p-float-label">
        <input pInputText id="username" type="text" [(ngModel)]="floatValue" />
        <label for="username">Username</label>
      </span>
    </p-card>

    <p-card styleClass="mb-4">
      <h2>Buttons</h2>
      <hr />

      <h3 #Buttons>Buttons</h3>
      <button type="button" pButton icon="pi pi-check" class="mr-2 mb-2"></button>
      <button type="button" pButton label="Submit" icon="pi pi-check" class="mr-2 mb-2"></button>
      <button type="button" pButton label="Submit" icon="pi pi-check" iconPos="right" class="mr-2 mb-2"></button>
      <button type="button" pButton label="Disabled" disabled="disabled" class="mr-2 mb-2"></button>

      <h3>Severities</h3>

      <button type="button" pButton label="Secondary" class="p-button-secondary mr-2 mb-2"></button>
      <button type="button" pButton label="Success" class="p-button-success mr-2 mb-2"></button>
      <button type="button" pButton label="Info" class="p-button-info mr-2 mb-2"></button>
      <button type="button" pButton label="Warning" class="p-button-warning mr-2 mb-2"></button>
      <button type="button" pButton label="Help" class="p-button-help mr-2 mb-2"></button>
      <button type="button" pButton label="Danger" class="p-button-danger mb-2"></button>

      <h3>Raised Buttons</h3>
      <button type="button" pButton label="Secondary" class="p-button-raised p-button-secondary mr-2 mb-2"></button>
      <button type="button" pButton label="Success" class="p-button-raised p-button-success mr-2 mb-2"></button>
      <button type="button" pButton label="Info" class="p-button-raised p-button-info mr-2 mb-2"></button>
      <button type="button" pButton label="Warning" class="p-button-raised p-button-warning mr-2 mb-2"></button>
      <button type="button" pButton label="Help" class="p-button-raised p-button-help mr-2 mb-2"></button>
      <button type="button" pButton label="Danger" class="p-button-raised p-button-danger mr-2 mb-2"></button>

      <h3>Rounded Buttons</h3>
      <button type="button" pButton label="Secondary" class="p-button-rounded p-button-secondary mr-2 mb-2"></button>
      <button type="button" pButton label="Success" class="p-button-rounded p-button-success mr-2 mb-2"></button>
      <button type="button" pButton label="Info" class="p-button-rounded p-button-info mr-2 mb-2"></button>
      <button type="button" pButton label="Warning" class="p-button-rounded p-button-warning mr-2 mb-2"></button>
      <button type="button" pButton label="Help" class="p-button-rounded p-button-help mr-2 mb-2"></button>
      <button type="button" pButton label="Danger" class="p-button-rounded p-button-danger mb-2"></button>

      <h3>Text Buttons</h3>
      <button type="button" pButton label="Secondary" class="p-button-secondary p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Success" class="p-button-success p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Info" class="p-button-info p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Warning" class="p-button-warning p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Help" class="p-button-help p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Danger" class="p-button-danger p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Plain" class="p-button-text p-button-plain mr-2 mb-2"></button>

      <h3>Raised Text Buttons</h3>
      <button type="button" pButton label="Primary" class="p-button-raised p-button-text mr-2 mb-2"></button>
      <button
        type="button"
        pButton
        label="Secondary"
        class="p-button-raised p-button-secondary p-button-text mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        label="Success"
        class="p-button-raised p-button-success p-button-text mr-2 mb-2"
      ></button>
      <button type="button" pButton label="Info" class="p-button-raised p-button-info p-button-text mr-2 mb-2"></button>
      <button
        type="button"
        pButton
        label="Warning"
        class="p-button-raised p-button-warning p-button-text mr-2 mb-2"
      ></button>
      <button type="button" pButton label="Help" class="p-button-raised p-button-help p-button-text mr-2 mb-2"></button>
      <button
        type="button"
        pButton
        label="Danger"
        class="p-button-raised p-button-danger p-button-text mr-2 mb-2"
      ></button>
      <button type="button" pButton label="Plain" class="p-button-raised p-button-text p-button-plain mb-2"></button>

      <h3>Outlined Buttons</h3>
      <button type="button" pButton label="Secondary" class="p-button-outlined p-button-secondary mr-2 mb-2"></button>
      <button type="button" pButton label="Success" class="p-button-outlined p-button-success mr-2 mb-2"></button>
      <button type="button" pButton label="Info" class="p-button-outlined p-button-info mr-2 mb-2"></button>
      <button type="button" pButton label="Warning" class="p-button-outlined p-button-warning mr-2 mb-2"></button>
      <button type="button" pButton label="Help" class="p-button-outlined p-button-help mr-2 mb-2"></button>
      <button type="button" pButton label="Danger" class="p-button-outlined p-button-danger mr-2 mb-2"></button>
      <button type="button" pButton label="Plain" class="p-button-outlined p-button-plain mb-2 mr-2"></button>

      <h3>Rounded Icon Buttons</h3>
      <button
        type="button"
        pButton
        icon="pi pi-bookmark"
        class="p-button-rounded p-button-secondary mr-2 mb-2"
      ></button>
      <button type="button" pButton icon="pi pi-search" class="p-button-rounded p-button-success mr-2 mb-2"></button>
      <button type="button" pButton icon="pi pi-user" class="p-button-rounded p-button-info mr-2 mb-2"></button>
      <button type="button" pButton icon="pi pi-bell" class="p-button-rounded p-button-warning mr-2 mb-2"></button>
      <button type="button" pButton icon="pi pi-heart" class="p-button-rounded p-button-help mr-2 mb-2"></button>
      <button type="button" pButton icon="pi pi-times" class="p-button-rounded p-button-danger mb-2"></button>

      <h3>Rounded Text Icon Buttons</h3>
      <button
        type="button"
        pButton
        icon="pi pi-bookmark"
        class="p-button-rounded p-button-secondary p-button-text mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-search"
        class="p-button-rounded p-button-success p-button-text mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-user"
        class="p-button-rounded p-button-info p-button-text mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-bell"
        class="p-button-rounded p-button-warning p-button-text mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-heart"
        class="p-button-rounded p-button-help p-button-text mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-times"
        class="p-button-rounded p-button-danger p-button-text mr-2 mb-2"
      ></button>

      <h3>Rounded and Outlined Icon Buttons</h3>
      <button
        type="button"
        pButton
        icon="pi pi-bookmark"
        class="p-button-rounded p-button-secondary p-button-outlined mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-search"
        class="p-button-rounded p-button-success p-button-outlined mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-user"
        class="p-button-rounded p-button-info p-button-outlined mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-bell"
        class="p-button-rounded p-button-warning p-button-outlined mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-heart"
        class="p-button-rounded p-button-help p-button-outlined mr-2 mb-2"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-times"
        class="p-button-rounded p-button-danger p-button-outlined mb-2"
      ></button>

      <h3>Badges</h3>
      <p-button label="Emails" badge="8" styleClass="mr-2"></p-button>
      <p-button
        label="Messages"
        icon="pi pi-users"
        styleClass="p-button-warning"
        badge="8"
        badgeClass="p-badge-danger"
      ></p-button>

      <h3>Button Set</h3>
      <span class="p-buttonset">
        <button type="button" pButton label="Save" icon="pi pi-check"></button>
        <button type="button" pButton label="Delete" icon="pi pi-trash"></button>
        <button type="button" pButton label="Cancel" icon="pi pi-times"></button>
      </span>
    </p-card>

    <p-card styleClass="mb-4">
      <h2 #Data>Data</h2>
      <hr />

      <p-table
        #dt
        [value]="customers"
        [(selection)]="selectedCustomers"
        dataKey="id"
        styleClass="p-datatable-customers"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [globalFilterFields]="['name', '.name', 'representative.name', 'status']"
      >
        <ng-template pTemplate="caption">
          <div class="table-header">
            Table
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="filterTable(dt, $event)" placeholder="Global Search" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="country.name">Country <p-sortIcon field="country.name"></p-sortIcon></th>
            <th pSortableColumn="representative.name">
              Representative <p-sortIcon field="representative.name"></p-sortIcon>
            </th>
            <th pSortableColumn="date">Date <p-sortIcon field="date"></p-sortIcon></th>
            <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
            <th pSortableColumn="activity">Activity <p-sortIcon field="activity"></p-sortIcon></th>
            <th style="width: 8rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
          <tr class="p-selectable-row">
            <td>
              <p-tableCheckbox [value]="customer"></p-tableCheckbox>
            </td>
            <td>
              <span class="column-title">Name</span>
              {{ customer.name }}
            </td>
            <td>
              <span class="column-title">Country</span>
              <img
                src="assets/demo/images/flag/flag_placeholder.png"
                [class]="'flag flag-' + customer.country.code"
                width="30"
              />
              <span class="image-text">{{ customer.country.name }}</span>
            </td>
            <td>
              <span class="column-title">Representative</span>
              <img
                [alt]="customer.representative.name"
                src="assets/demo/images/avatar/{{ customer.representative.image }}"
                width="32"
                style="vertical-align: middle"
              />
              <span class="image-text">{{ customer.representative.name }}</span>
            </td>
            <td>
              <span class="column-title">Date</span>
              {{ customer.date }}
            </td>
            <td>
              <span class="column-title">Status</span>
              <span [class]="'customer-badge status-' + customer.status">{{ customer.status }}</span>
            </td>
            <td>
              <span class="column-title">Activity</span>
              <p-progressBar
                [value]="customer.activity"
                [showValue]="false"
                [style]="{ height: '4px' }"
              ></p-progressBar>
            </td>
            <td style="text-align: center">
              <button pButton type="button" icon="pi pi-cog"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">No customers found.</td>
          </tr>
        </ng-template>
      </p-table>

      <h3 #ContextMenu>ContextMenu</h3>
      <div #cmtext>Right click to display.</div>
      <p-contextMenu [model]="contextMenuItems" [target]="cmtext"></p-contextMenu>
    </p-card>

    <p-card styleClass="mb-4">
      <h2 #Panels>Panels</h2>
      <hr />

      <h3 #Panel>Panel</h3>
      <p-panel header="Header" [toggleable]="true">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est laborum.
        </p>
      </p-panel>

      <h3 #Fieldset>Fieldset</h3>
      <p-fieldset legend="Legend" [toggleable]="true">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est laborum.
        </p>
      </p-fieldset>
    </p-card>

    <p-card styleClass="mb-4">
      <h2 #Overlay>Overlay</h2>
      <hr />

      <h3 #OverlayPanel>Overlay Panel</h3>
      <p-button
        [label]="selectedProduct ? selectedProduct.name : 'Choose'"
        icon="pi pi-search"
        (click)="op.toggle($event)"
      ></p-button>

      <p-overlayPanel #op [showCloseIcon]="true" [style]="{ width: '450px' }">
        <ng-template pTemplate>
          <p-table
            [value]="products"
            selectionMode="single"
            [(selection)]="selectedProduct"
            (onRowSelect)="onRowSelect($event, op)"
            [paginator]="true"
            [rows]="5"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name">Name<p-sortIcon field="name"></p-sortIcon></th>
                <th>Image</th>
                <th pSortableColumn="price">Price <p-sortIcon field="price"></p-sortIcon></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-product>
              <tr [pSelectableRow]="rowData">
                <td>{{ product.name }}</td>
                <td>
                  <img
                    src="assets/demo/images/product/{{ product.image }}"
                    [attr.alt]="product.image"
                    class="product-image"
                  />
                </td>
                <td>{{ product.price }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-template>
      </p-overlayPanel>

      <h3 #ConfirmPopup>Confirm Popup</h3>
      <button
        (click)="showConfirmPopup($event)"
        pButton
        icon="pi pi-check"
        label="Confirm"
        class="p-button-success"
      ></button>

      <p-confirmPopup key="popup"></p-confirmPopup>

      <h3 #ConfirmDialog>Confirm Dialog</h3>
      <p-confirmDialog
        [style]="{ width: '30vw' }"
        [baseZIndex]="10000"
        rejectButtonStyleClass="p-button-text"
        key="dialog"
      ></p-confirmDialog>
      <p-button (click)="showConfirmDialog()" icon="pi pi-check" label="Confirm" styleClass="p-button-help"></p-button>
    </p-card>

    <p-card styleClass="mb-4">
      <h3 #Menus>Menus</h3>
      <hr />

      <h3 #OverlayMenu>Overlay Menu</h3>
      <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
      <button
        type="button"
        pButton
        icon="pi pi-angle-down"
        label="Options"
        (click)="menu.toggle($event)"
        style="width: auto"
      ></button>

      <h3 #TieredMenu>Tiered Menu</h3>
      <p-tieredMenu [model]="tieredMenuItems"></p-tieredMenu>

      <h3 #PlainMenu>Plain Menu</h3>
      <p-menu [model]="menuItems"></p-menu>
    </p-card>

    <p-card styleClass="mb-4">
      <h2 #Messages>Messages</h2>
      <hr />

      <h3 #InlineMessage>Inline Message</h3>
      <p-message severity="info" text="Message Content" class="mr-2"></p-message>
      <p-message severity="success" text="Message Content" class="mr-2"></p-message>
      <p-message severity="warn" text="Message Content" class="mr-2"></p-message>
      <p-message severity="error" text="Message Content" class="mr-2"></p-message>

      <div class="mt-4">
        <input type="text" pInputText placeholder="Username" class="ng-dirty ng-invalid p-invalid mr-2" />
        <p-message severity="error" text="Field is required"></p-message>
      </div>

      <div class="mt-4">
        <input type="text" pInputText placeholder="Email" class="ng-dirty ng-invalid p-invalid mr-2" />
        <p-message severity="error"></p-message>
      </div>
    </p-card>
  </div>
</div>
